module.exports = __webpack_public_path__ + "img/user-y-marker.c56f539.svg";